var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-detail-files" },
    [
      _vm.recordFilesLoaded && _vm.recordFiles.length > 0
        ? _c(
            "div",
            { staticClass: "table-edit-docs" },
            [
              _vm.galleryFiles.length > 0 && _vm.galleryActiveIndex != null
                ? _c("div", { staticClass: "collapse-body pb-0" }, [
                    _c("h3", [_vm._v("Dokumentenvorschau")]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.galleryFiles.length > 0 && _vm.galleryActiveIndex != null
                ? _c(
                    "div",
                    {
                      staticClass: "preview collapse-body mb-5",
                      staticStyle: { height: "450px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.galleryActiveTitle,
                              expression: "galleryActiveTitle",
                            },
                          ],
                          staticClass: "galleryActiveTitle text-center",
                          staticStyle: { "margin-bottom": "10px" },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.galleryActiveTitle) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("csp-file-gallery", {
                        attrs: {
                          active: _vm.galleryActiveIndex,
                          files: _vm.galleryFiles,
                          height: 400,
                          width: 400 / 1.414,
                        },
                        on: { change: _vm.onGalleryChange },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("b-table", {
                attrs: {
                  fields: _vm.fileTableFields,
                  items: _vm.recordFilesForTable,
                  responsive: true,
                  striped: "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "head()",
                      fn: function (data) {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(data.label.toUpperCase()) +
                              "\n            "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(actions)",
                      fn: function (data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "mb-3",
                              staticStyle: { "text-align": "right" },
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#", title: "Datei ansehen" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.galleryShow(data)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "inticon-manuals" })]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.canSignDocument(data)
                            ? _c(
                                "div",
                                { staticClass: "my-1" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn-action w-100",
                                      staticStyle: { "white-space": "nowrap" },
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.openModal(data, false)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "inticon-signature",
                                        staticStyle: {
                                          "font-size": "18px",
                                          color: "#fff",
                                        },
                                      }),
                                      _vm._v(
                                        "\n                        Unterschreiben\n                    "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canCounterSignDocument(data)
                            ? _c(
                                "div",
                                { staticClass: "my-1" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn-action w-100",
                                      staticStyle: { "white-space": "nowrap" },
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.openModal(data, true)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "inticon-signature",
                                        staticStyle: {
                                          "font-size": "18px",
                                          color: "#fff",
                                        },
                                      }),
                                      _vm._v(
                                        "\n                        Gegenzeichnen\n                    "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "cell(dateSet)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.formatDate(data.value)) +
                              "\n            "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1770716001
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasNoFiles
        ? _c(
            "div",
            { staticClass: "collapse-body" },
            [
              _c("b-alert", { attrs: { show: true, variant: "info" } }, [
                _vm._v("\n            Noch keine Dateien vorhanden.\n        "),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("b-modal", {
        attrs: { title: "Digitale Unterschrift" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ visible }) {
              return [
                visible
                  ? _c("div", { staticClass: "sign-documents-modal-content" }, [
                      _c(
                        "div",
                        { staticClass: "collapse-body" },
                        [
                          _c(
                            "b-form",
                            {
                              attrs: { inline: "", novalidate: false },
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.requestSignature.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("csp-form-group-input", {
                                staticClass: "mr-3",
                                attrs: {
                                  form: _vm.signForm,
                                  "label-class": "mr-2",
                                  property: "signaturePlace",
                                  required: "",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn-action",
                                      attrs: {
                                        disabled: !_vm.isSignButtonEnabled,
                                        type: "submit",
                                        variant: "primary",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "inticon-signature",
                                      }),
                                      _vm._v(" "),
                                      _vm.signForm.getProperty(
                                        "isCounterSignature"
                                      )
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                                    Gegenzeichnen\n                                "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.signForm.getProperty(
                                        "isCounterSignature"
                                      )
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                                    Unterschreiben\n                                "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isSignButtonLoading
                                        ? _c("span", {
                                            staticClass:
                                              "spinner-border spinner-border-sm",
                                            attrs: {
                                              "aria-hidden": "true",
                                              role: "status",
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "modal-footer",
            fn: function ({ ok }) {
              return [
                _c(
                  "b-button",
                  { attrs: { variant: "tertiary" }, on: { click: ok } },
                  [_vm._v("\n                Schließen\n            ")]
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.isModalOpen,
          callback: function ($$v) {
            _vm.isModalOpen = $$v
          },
          expression: "isModalOpen",
        },
      }),
      _vm._v(" "),
      _vm.signatureCollection
        ? _c("csp-sign-document", {
            ref: "signDocument",
            attrs: {
              "build-file-download-url": _vm.buildFileDownloadUrl,
              "record-id": _vm.recordId,
              "signature-collection": _vm.signatureCollection,
            },
            on: { abort: _vm.handleSignAbort, sign: _vm.handleSign },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }